const HANDLE_PATTERN = /^[A-Za-z0-9_.]{1,30}$/;

export type HandleNormalizationResult =
  | { ok: true; handle: string }
  | { ok: false; error: string };

function stripUrlHandle(pathname: string) {
  return pathname.split("/").filter(Boolean)[0] ?? "";
}

export function normalizeInstagramHandle(input: string): HandleNormalizationResult {
  const trimmed = input.trim();

  if (!trimmed) {
    return { ok: false, error: "validationEmpty" };
  }

  let candidate = trimmed;
  const hasScheme = /^[a-z][a-z\d+\-.]*:\/\//i.test(trimmed);
  const looksLikeDomainInput = /^(www\.)?[a-z0-9.-]+\.[a-z]{2,}/i.test(trimmed);
  const hasSlash = trimmed.includes("/");
  const looksLikeUrl = hasScheme || looksLikeDomainInput || hasSlash;

  if (looksLikeUrl) {
    try {
      const url = new URL(hasScheme ? trimmed : `https://${trimmed}`);
      const hostname = url.hostname.toLowerCase();

      if (hostname !== "instagram.com" && hostname !== "www.instagram.com") {
        return { ok: false, error: "validationInvalidProviderUrl" };
      }

      candidate = stripUrlHandle(url.pathname);
    } catch {
      return { ok: false, error: "validationInvalidUrl" };
    }
  }

  const normalized = candidate.replace(/^@/, "").trim();

  if (!normalized) {
    return { ok: false, error: "validationEmpty" };
  }

  if (normalized.includes("@") || /\s/.test(normalized)) {
    return { ok: false, error: "validationSpacesOrAt" };
  }

  if (!HANDLE_PATTERN.test(normalized)) {
    return {
      ok: false,
      error: "validationLengthOrChars",
    };
  }

  return { ok: true, handle: normalized };
}
